import React, {useCallback, useMemo} from 'react';
import {format, max, min, sub, add} from "date-fns";
import CalendrierReservationCell from "./calendrier-reservation-cell";
import IReservationCalendrier from "../../models/IReservationCalendrier";
import {useCalendrierProps} from "./calendrier";
import {TypeCalendrier} from './calendrier-interfaces';

function CalendrierReservations({data}: { data: IReservationCalendrier[] }) {
    const {dateCourrante, dateCourranteFin, typeCalendrier, cellUnitesDimensions, selectedTypeUnite, setIsLoading} = useCalendrierProps();
    const reservationCells = useMemo(() => data?.map((reservation, index) => {

        const uniteDimensions = cellUnitesDimensions[`${selectedTypeUnite?.id}|${reservation.idUnite}`];
        if (!uniteDimensions) return null;
        const dateCourranteString = format(dateCourrante, typeCalendrier === TypeCalendrier.Jours ? "yyyyMMdd" : "yyyyMM");
        const cellDateAffichageDebut = uniteDimensions[`${selectedTypeUnite?.id}|${reservation.idUnite}|${dateCourranteString}`];
        const dateDebutString = format(reservation.dateDebut, typeCalendrier === TypeCalendrier.Jours ? "yyyyMMdd" : "yyyyMM");
        const dateFinString = format(min([dateCourranteFin, sub(new Date(reservation.dateFin), {['days']: 1})]), typeCalendrier === TypeCalendrier.Jours ? "yyyyMMdd" : "yyyyMM");

        const cellDebut = dateCourrante > new Date(reservation.dateDebut)
            ? cellDateAffichageDebut
            : uniteDimensions[`${selectedTypeUnite?.id}|${reservation.idUnite}|${dateDebutString}`];

        let cellFin = uniteDimensions[`${selectedTypeUnite?.id}|${reservation.idUnite}|${dateFinString}`];
        if (!cellFin) {
            const dateFin = new Date(reservation.dateFin);
            for (var d = new Date(reservation.dateDebut); d <= dateFin; d = add(d, {['days']: 1})) {
                let cellOffset = uniteDimensions[`${selectedTypeUnite?.id}|${reservation.idUnite}|${format(d, typeCalendrier === TypeCalendrier.Jours ? "yyyyMMdd" : "yyyyMM")}`];
                if (cellOffset) {
                    cellFin = cellOffset;
                } else {
                    break;
                }
            }
        }

        return <CalendrierReservationCell
            key={`${selectedTypeUnite?.id}|${reservation.idReservationDetail}`}
            cellDebutOffsetLeft={cellDebut?.OffsetLeft}
            cellDebutOffsetTop={cellDebut?.OffsetTop}
            cellDebutOffsetHeight={cellDebut?.OffsetHeight}
            cellFinOffsetWidth={cellFin?.OffsetWidth}
            cellFinOffsetLeft={cellFin?.OffsetLeft}
            reservation={reservation}
        />
    }), [data, cellUnitesDimensions, selectedTypeUnite?.id, typeCalendrier, dateCourrante])

    if (!data || !cellUnitesDimensions || cellUnitesDimensions && Object.keys(cellUnitesDimensions).length === 0) return null
    return <div className="reservation-cells">
        {reservationCells}
    </div>
}

export default CalendrierReservations;